import React from 'react';
import T from 'prop-types';

import MetricOverview from './MetricOverview';
import MarketShareChart from '../../../_shared/components/MarketShareChart';
import SectionError from '../../../_shared/components/SectionError';
import SimpleCard from '../../../../../components/Card/SimpleCard';
import { basePartialFilters, initMaxDate } from '../../configs/chart-config';

const emptyArray = [];

const cumulativeCaption = {
  text: (
    <>
      Each app starts at 0 at the beginning of the selected period. A rising line means gaining
      share; <br /> falling means losing it. The steeper the slope, the faster the shift.
    </>
  ),
  placement: 'chart-caption',
};

const MarketOverviewCard = ({ marketOverview, apps = emptyArray, isAppsPending, isPress }) => {
  const { data, settings } = marketOverview;

  if (settings.error) return <SectionError />;

  return (
    <SimpleCard contentDisableGutters actionsLeft={<div className="highcharts-watermark" />}>
      <MetricOverview data={data} isPending={settings.pending} isPress={isPress} />
      <MarketShareChart
        apps={apps}
        series={data.time_series?.market_share}
        isPending={isAppsPending || settings.pending}
        isPress={isPress}
        partialFilters={basePartialFilters}
        maxDate={initMaxDate}
        cumulativeCaption={cumulativeCaption}
      />
    </SimpleCard>
  );
};

MarketOverviewCard.propTypes = {
  marketOverview: T.shape({
    data: T.object.isRequired,
    settings: T.object.isRequired,
  }).isRequired,
  apps: T.array,
  isAppsPending: T.bool.isRequired,
  isPress: T.bool,
};

export default MarketOverviewCard;
